import { AnalyticsState, MutationClass } from '../../../models';

export class ClearDataMutation implements MutationClass {

  public static execute(state: AnalyticsState): void {
    Object.assign(state, {
      data: {
        overall: {
          dist: {
            currentPeriod: undefined
          },
          pivots: {},
          sessions: {
            currentPeriod: undefined
          }
        },
        queries: {},
        search: {},
        ids: {}
      }
    });
  }

}
